import { Component } from '@angular/core';

@Component({
  standalone: true,
  selector: 'lx-form-error-message',
  templateUrl: './form-error-message.component.html',
  styleUrls: ['./form-error-message.component.scss'],
})
export class FormErrorMessageComponent {}
